<template>
  <v-container id="dashboard" tag="section" class="px-10 pb-10">
    <v-overlay :value="isLoadingActions">
      <v-progress-circular color="#FBB040" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row justify="end" class="pr-2">
      <v-col cols="12" sm="auto">
        <v-btn
          color="success"
          x-large
          class="text-white"
          min-width="180"
          width="100%"
          button
          dark
          @click="createNewDevice"
        >
          <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Lưu lại
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="px-8 py-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row justify="space-between" class="mb-4">
              <v-col cols="12" sm="3">
                <h2 class="text-xl font-medium">Chi tiết sửa chữa</h2>
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <v-select
                  v-model="deliveryStatus"
                  prepend-inner-icon="mdi-list-status"
                  color="#FBB040"
                  :items="deliveryStatusList"
                  outlined
                  :rules="[rules.required]"
                  no-data-text="Không có dữ liệu"
                  label="Trạng thái*"
                  item-text="name"
                  loading="true"
                  item-value="id"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <DatePicker
                  :rules="[rules.required]"
                  v-model="receivedDate"
                  label="Ngày nhận*"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <DatePicker
                  :rules="[rules.required]"
                  v-model="fixedPlanDate"
                  label="Ngày dự kiến trả*"
                /> </v-col
            ></v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="productName"
                  :rules="[rules.required]"
                  outlined
                  prepend-inner-icon="mdi-numeric"
                  color="#FBB040"
                  label="Tên sản phẩm*"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="productIMEI"
                  outlined
                  prepend-inner-icon="mdi-passport-biometric"
                  color="#FBB040"
                  label="IMEI"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="productLockScreen"
                  outlined
                  prepend-inner-icon="mdi-counter"
                  color="#FBB040"
                  label="Mật khẩu khoá màn hình"
                  :hide-details="isMobile"
                />
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="customerName"
                  outlined
                  prepend-inner-icon="mdi-account"
                  color="#FBB040"
                  label="Tên khách hàng*"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="customerPhone"
                  outlined
                  prepend-inner-icon="mdi-phone"
                  color="#FBB040"
                  label="Số điện thoại"
                  :hide-details="isMobile"
                  :maxLength="20"
                  @keypress="filter(evt)"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="productGuarran"
                  outlined
                  prepend-inner-icon="mdi-account-child"
                  color="#FBB040"
                  label="Bảo hành*"
                  :hide-details="isMobile"
                />
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <v-textarea
                  rows="1"
                  auto-grow
                  v-model="receiveStatus"
                  prepend-inner-icon="mdi-import"
                  outlined
                  label="Tình trạng tiếp nhận"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-select
                  v-model="fixStatus"
                  prepend-inner-icon="mdi-auto-fix"
                  color="#FBB040"
                  :items="fixStatusList"
                  outlined
                  :rules="[rules.required]"
                  no-data-text="Không có dữ liệu"
                  label="Tình trạng sửa chữa*"
                  item-text="name"
                  loading="true"
                  item-value="id"
                  :hide-details="isMobile"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-textarea
                  rows="1"
                  auto-grow
                  v-model="fixContent"
                  prepend-inner-icon="mdi-content-save-cog"
                  outlined
                  label="Nội dung sửa chữa"
                /> </v-col
            ></v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" lg="4">
                <money-input
                  v-model="priceFix"
                  v-bind:label="label"
                  v-bind:placeholder="placeholder"
                  v-bind:readonly="readonly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  v-bind:clearable="clearable"
                  v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                  v-bind:options="options"
                  v-bind:properties="properties"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <money-input
                  v-model="addCost"
                  v-bind:label="labelChiPhi"
                  v-bind:placeholder="placeholder"
                  v-bind:readonly="readonly"
                  v-bind:disabled="disabled"
                  v-bind:outlined="outlined"
                  v-bind:clearable="clearable"
                  v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                  v-bind:options="options"
                  v-bind:properties="properties"
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-text-field
                  v-model="technicianId"
                  outlined
                  prepend-inner-icon="mdi-currency-twd"
                  color="#FBB040"
                  label="Kỹ thuật viên"
                  :hide-details="isMobile"
                />
              </v-col>
            </v-row>
            <v-row class="mt-1">
              <v-col cols="12" sm="12" lg="12">
                <v-textarea
                  rows="1"
                  auto-grow
                  v-model="note"
                  prepend-inner-icon="mdi-note-alert-outline"
                  outlined
                  hide-details
                  label="Lưu ý"
                /> </v-col
            ></v-row>
            <template> </template>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { mapState } from "vuex";
import MoneyInput from "~/components/atoms/MoneyInput.vue";
import { required } from "~/utils/validation";
import VueUploadMultipleImage from "~/components/molecules/VueUploadMultipleImage.vue";
import DatePicker from "~/components/atoms/DatePicker.vue";

export default {
  name: "CreateDevice",
  components: { MoneyInput, VueUploadMultipleImage, DatePicker },
  data() {
    return {
      scope: "phonefix",
      label: "Giá sửa chữa",
      labelChiPhi: "Chi phí",
      placeholder: " ",
      readonly: false,
      disabled: false,
      outlined: true,
      clearable: true,
      valueWhenIsEmpty: "",
      options: {
        locale: "it-IT",
        prefix: "",
        suffix: "vnđ",
        length: 30,
        precision: 0,
      },
      properties: {
        hint: "Chú ý đơn vị tính",
        prependInnerIcon: "mdi-currency-usd",
        color: "#FBB040",
      },
      priceFix: null,
      addCost: null,
      technicianId: null,
      productName: null,
      productIMEI: null,
      priceFix: null,
      productGuarran: null,
      receiveStatus: null,
      note: null,
      productLockScreen: null,
      customerName: null,
      customerPhone: null,
      fixStatus: 2,
      fixContent: null,
      fixStatusList: [
        {
          id: 1,
          name: "Bảo hành sửa",
        },
        {
          id: 2,
          name: "Đang sửa",
        },
        {
          id: 3,
          name: "Chờ linh kiện",
        },
        {
          id: 4,
          name: "Đã sửa xong",
        },
        {
          id: 5,
          name: "Chờ giao cho khách",
        },
        {
          id: 6,
          name: "Không sửa được",
        },
        {
          id: 7,
          name: "Kiểm tra báo giá",
        },
        {
          id: 8,
          name: "Khách không sửa",
        },
        {
          id: 9,
          name: "Thu lại máy",
        },
      ],
      deliveryStatusList: [
        {
          id: 1,
          name: "Mới tạo",
        },
        {
          id: 2,
          name: "Đang sửa",
        },
        {
          id: 3,
          name: "Hoàn thành",
        },
      ],
      deliveryStatus: 1,
      deviceCode: null,
      valid: true,
      rules: {
        required,
      },
      isLoading: false,
      isLoadingActions: false,
      valid: false,
      messageError: EMPTY,
      receivedDate: null,
      fixedPlanDate: null,
    };
  },
  async created() {
    Date.prototype.addDays = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };
    this.receivedDate = new Date().toLocaleDateString("vi-VN").replaceAll("/", "-");
    this.fixedPlanDate = new Date().toLocaleDateString("vi-VN").replaceAll("/", "-");
  },
  methods: {
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async createNewDevice() {
      await this.$refs.form.validate();
      if (this.valid) {
        try {
          this.isLoadingActions = true;
          const { phonefixId } = this.$route.params;
          if (this.addCost === "") {
            this.addCost = 0;
          }
          await this.$services.phonefixService.createPhoneFix({
            receivedDate: this.receivedDate,
            fixedPlanDate: this.fixedPlanDate,
            receiveStatus: this.receiveStatus,
            productName: this.productName,
            productIMEI: this.productIMEI,
            productLockScreen: this.productLockScreen,
            customerName: this.customerName,
            customerPhone: this.customerPhone,
            techniciansId: this.technicianId,
            fixContent: this.fixContent,
            priceFix: this.priceFix,
            guarrantyDate: this.productGuarran,
            fixStatus: this.fixStatus,
            deliveryStatus: this.deliveryStatus,
            note: this.note,
            addCost: this.addCost,
          });
        } catch (error) {
          console.log(error);
        } finally {
          this.isLoadingActions = false;
          this.$router?.push({ name: "PhoneFixList" });
        }
      }
    },
  },
  computed: {
    ...mapState({
      role: (state) => state.user.roleName,
      totalImage: (state) => state.device.totalImage,
      images: (state) => state.device.images,
    }),
    isMobile() {
      return window.innerWidth <= 640;
    },
  },
  beforeDestroy() {
    this.$store.commit("device/setImageList", []);
  },
};
</script>
